var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { MinLength } from "class-validator";
import { GraphQLNonEmptyString } from "graphql-scalars";
import { Field, InputType } from "type-graphql";
import { GlobalIdScalar } from "../scalars/GlobalId.js";
let CreateFeedInput = class CreateFeedInput {
    title;
    textContent;
    imageUuid;
};
__decorate([
    MinLength(5),
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], CreateFeedInput.prototype, "title", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], CreateFeedInput.prototype, "textContent", void 0);
__decorate([
    Field(() => GlobalIdScalar, { nullable: true }),
    __metadata("design:type", Object)
], CreateFeedInput.prototype, "imageUuid", void 0);
CreateFeedInput = __decorate([
    InputType()
], CreateFeedInput);
export { CreateFeedInput };
let SetFeedInput = class SetFeedInput {
    title;
    textContent;
};
__decorate([
    MinLength(5),
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], SetFeedInput.prototype, "title", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], SetFeedInput.prototype, "textContent", void 0);
SetFeedInput = __decorate([
    InputType()
], SetFeedInput);
export { SetFeedInput };
//# sourceMappingURL=CreateFeedInput.js.map